import { useEffect, useRef } from "react";
import { createChart } from "lightweight-charts";
import moment from "moment";

const AnalysisLine = ({ lineData, showNormInd, setShowNormInd, showCloseInd, setShowCloseInd }) => {
    const chartContainerRef = useRef(null);
    const chartRef = useRef(null);
    const normIndSeriesRef = useRef(null);
    const closeIndSeriesRef = useRef(null);
    const tooltipRef = useRef(null);

    useEffect(() => {
        // Create chart
        const chart = createChart(chartContainerRef.current, {
            width: chartContainerRef.current.offsetWidth,
            height: 200,
            layout: {
                backgroundColor: "#ffffff",
                textColor: "#000000",
            },
            grid: {
                vertLines: { color: "#e1e1e1" },
                horzLines: { color: "#e1e1e1" },
            },
            timeScale: {
                timeVisible: true,
                secondsVisible: false,
                tickMarkFormatter: (time) => {
                    const formattedDate = moment(time).format("YYY-MM-DD")
                    return time;
                },
            },
            leftPriceScale: {
                visible: true,
                borderVisible: true,
                autoScale: true,
                scaleMargins: {
                    top: 0.3, // Adjust to control top margin
                    bottom: 0.3, // Adjust to control bottom margin
                },
            },
            rightPriceScale: {
                visible: false,
            },
        });

        // Add series for NormInd
        const normIndSeries = chart.addLineSeries({
            color: "orange",
            lineWidth: 2,
        });
        normIndSeries.setData(
            lineData.map((item) => ({ time: item.date, value: item.normPort }))
        );

        // Add series for CloseInd
        const closeIndSeries = chart.addLineSeries({
            color: "blue",
            lineWidth: 2,
        });
        closeIndSeries.setData(
            lineData.map((item) => ({ time: item.date, value: item.normInd }))
        );

        chart.timeScale().fitContent();

        // Save references
        chartRef.current = chart;
        normIndSeriesRef.current = normIndSeries;
        closeIndSeriesRef.current = closeIndSeries;

        // Handle custom tooltips
        chart.subscribeCrosshairMove((param) => {
            if (!tooltipRef.current) return;

            const normIndSeries = normIndSeriesRef.current;
            const closeIndSeries = closeIndSeriesRef.current;

            if (!param.time || !param.point || !normIndSeries || !closeIndSeries) {
                tooltipRef.current.style.display = "none";
                return;
            }

            const pointNormInd = param.seriesData.get(normIndSeries);
            const pointCloseInd = param.seriesData.get(closeIndSeries);
            const showNormPop = pointNormInd && showNormInd
            const showClosePop = pointCloseInd && showCloseInd
            const hoverProximity = 5; // Adjust proximity sensitivity
            const isHoveringNormInd =
                showNormPop &&
                Math.abs(
                    param.point.y - normIndSeries.priceToCoordinate(pointNormInd.value)
                ) <= hoverProximity;

            const isHoveringCloseInd =
                showClosePop &&
                Math.abs(
                    param.point.y - closeIndSeries.priceToCoordinate(pointCloseInd.value)
                ) <= hoverProximity;

            if (isHoveringNormInd || isHoveringCloseInd) {
                tooltipRef.current.style.display = "block";

                // Position tooltip within the canvas
                const chartBounds = chartContainerRef.current.getBoundingClientRect();
                const tooltipWidth = tooltipRef.current.offsetWidth;
                const tooltipHeight = tooltipRef.current.offsetHeight;

                const tooltipX = Math.min(
                    Math.max(param.point.x - tooltipWidth / 2, 0), // Ensure tooltip doesn't go outside the left boundary
                    chartBounds.width - tooltipWidth // Ensure tooltip doesn't go outside the right boundary
                );

                const tooltipY = Math.min(
                    Math.max(param.point.y - tooltipHeight - 10, 0), // Ensure tooltip doesn't go above the top boundary
                    chartBounds.height - tooltipHeight // Ensure tooltip doesn't go below the bottom boundary
                );

                tooltipRef.current.style.left = `${tooltipX}px`;
                tooltipRef.current.style.top = `${tooltipY}px`;

                // Format the date using Moment.js
                const formattedDate = moment(param.time).format("MMM DD, YYYY");

                // Update tooltip content
                tooltipRef.current.innerHTML = `
          <div style="font-weight: bold; font-size: 12px;">Date: ${formattedDate}</div>
          ${isHoveringNormInd
                        ? `<div style="color: orange;">NormInd: ${pointNormInd.value}</div>`
                        : ""
                    }
          ${isHoveringCloseInd
                        ? `<div style="color: blue;">CloseInd: ${pointCloseInd.value}</div>`
                        : ""
                    }
        `;
            } else {
                tooltipRef.current.style.display = "none";
            }
        });

        // Resize handling
        const handleResize = () => {
            chart.resize(chartContainerRef.current.offsetWidth, 200);
        };
        window.addEventListener("resize", handleResize);

        return () => {
            chart.remove();
            window.removeEventListener("resize", handleResize);
        };
    }, [lineData, showCloseInd, showNormInd]);

    useEffect(() => {
        if (normIndSeriesRef.current) {
            normIndSeriesRef.current.applyOptions({
                visible: showNormInd,
            });
        }
    }, [showNormInd]);

    useEffect(() => {
        if (closeIndSeriesRef.current) {
            closeIndSeriesRef.current.applyOptions({
                visible: showCloseInd,
            });
        }
    }, [showCloseInd]);

    return (
        <div style={{ position: "relative" }}>
            <div
                ref={chartContainerRef}
                style={{
                    position: "relative",
                    width: "100%",
                    // height: "400px",
                }}
            />
            <div
                ref={tooltipRef}
                style={{
                    position: "absolute",
                    display: "none",
                    padding: "8px",
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    border: "1px solid #d3d3d3",
                    borderRadius: "4px",
                    pointerEvents: "none",
                    whiteSpace: "nowrap",
                    fontSize: "12px",
                    zIndex: 100,
                }}
            ></div>
            
                {/* <Row className='g-0 justify-content-center aign-items-cente mt-2'> // Hari K:13-01-2025 need to remove later
                    <Col md={8} className='p-2 text-center'>
                        <button type="button" className='btn btn-sm btn-primary me-2' onClick={() => setShowNormInd((prev) => !prev)}>
                            Toggle NormInd
                        </button>
                        <button type="button" className='btn btn-sm btn-primary' onClick={() => setShowCloseInd((prev) => !prev)}>
                            Toggle CloseInd
                        </button>
                    </Col>
                </Row> */}
           
        </div>
    );
};

export default AnalysisLine;
